import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "token-text-h4 mb-6",
  "data-test": "sign-in-title"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}

import { ref } from 'vue';

import CustomButton from '@shared/components/UIElements/CustomButton.vue';
import CustomTextInput from '@shared/components/UIElements/CustomTextInput.vue';
import TextBetweenLines from '@shared/components/UIElements/TextBetweenLines.vue';
import { useRoute, useRouter } from 'vue-router';
import { ButtonLevels, Severity } from '@shared/enums';
import sessionService from '@/services/sessionService';
import { redirectIfConnected } from '@/utils/redirect';
import { carriedReturnTo } from '@/utils/returnTo';
import { useApplicationSignIn } from '@/utils/applicationSignIn';
import Message from '@/shared/components/UIElements/Message.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginBar',
  setup(__props) {

const routeur = useRouter();
const route = useRoute();
// An application's sign-in returns here through the portal's own sign-in page.
const { application, cancel, cancelling } = useApplicationSignIn();

const form = ref({
  login: '',
  password: '',
});
const loading = ref(false);
const btnText = ref('Sign in');

const buttonState = ref(undefined);
const errors = ref(null);

const doLogin = () => {
  loading.value = true;
  errors.value = null;

  sessionService
    .login(form.value.login, form.value.password)
    .then(() => {
      redirectIfConnected()
        .catch(() => {
          console.error('Error during redirection after login');
        })
        .finally(() => {
          loading.value = false;
        });
    })
    .catch((error) => {
      errors.value =
        error.response?.data?.errors?.[0]?.detail || 'You could not be signed in. Try again.';
      loading.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "authBar bar",
    novalidate: "",
    onSubmit: _withModifiers(doLogin, ["prevent"])
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(application) ? `Sign in to continue to ${_unref(application)}` : 'Sign in'), 1),
    _cache[5] || (_cache[5] = _createElementVNode("label", {
      class: "token-text-regular",
      for: "login-email"
    }, "Email", -1)),
    _createVNode(CustomTextInput, {
      class: "mt-2",
      modelValue: form.value.login,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.login) = $event)),
      "input-id": "login-email",
      name: "email",
      autocomplete: "username",
      placeholder: "hello@email.com"
    }, null, 8, ["modelValue"]),
    _cache[6] || (_cache[6] = _createElementVNode("label", {
      class: "token-text-regular mt-2",
      for: "login-password"
    }, "Password", -1)),
    _createVNode(CustomTextInput, {
      class: "mt-2",
      modelValue: form.value.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
      "input-id": "login-password",
      name: "password",
      autocomplete: "current-password",
      placeholder: "••••••••",
      type: "password"
    }, null, 8, ["modelValue"]),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Message, {
            severity: _unref(Severity).DANGER,
            title: 'Error',
            text: errors.value
          }, null, 8, ["severity", "text"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CustomButton, {
      type: "submit",
      level: _unref(ButtonLevels).Primary,
      class: "cta mt-2",
      status: buttonState.value,
      text: btnText.value,
      disabled: loading.value,
      loading: loading.value
    }, null, 8, ["level", "status", "text", "disabled", "loading"]),
    _createVNode(TextBetweenLines, { class: "my-4" }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "token-text-color-secondary token-text-microbold token-text-transform-uppercase token-text-font-iAWriterDuoV" }, " or ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(CustomButton, {
      level: _unref(ButtonLevels).Secondary,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(routeur).push({ name: 'register', query: _unref(carriedReturnTo)(_unref(route).query) }))),
      class: "cta mt-2",
      text: "Create an account"
    }, null, 8, ["level"]),
    _createVNode(CustomButton, {
      level: _unref(ButtonLevels).Tertiary,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(routeur).push({ name: 'forgot-password', query: _unref(carriedReturnTo)(_unref(route).query) }))),
      class: "cta mt-2",
      text: "Forgot your password?"
    }, null, 8, ["level"]),
    (_unref(application))
      ? (_openBlock(), _createBlock(CustomButton, {
          key: 1,
          "data-test": "cancel-application",
          level: _unref(ButtonLevels).Tertiary,
          class: "cta mt-2",
          text: `Cancel and go back to ${_unref(application)}`,
          disabled: _unref(cancelling),
          loading: _unref(cancelling),
          onClick: _unref(cancel)
        }, null, 8, ["level", "text", "disabled", "loading", "onClick"]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})